export default {"src":"/_next/static/media/garage_black.a9ba2b61.svg","height":18,"width":18};